import React, { ChangeEvent, FC } from 'react'
import styles from 'styles/components/form.module.scss'
import cardStyles from 'styles/components/card.module.scss'
import text from 'styles/utility/text.module.scss'
import { CardInner } from 'components/Card'
import { Spacer } from 'components/Utility'
import { FlexColumn, FlexRow } from 'components/Flex'
import { BreadPreorderTag, LightTag } from 'components/Tag'
import { SmallLabel } from 'components/Label'
import { StockType } from 'types/stock'

type Props = {
  breadId: string
  breadName: string
  imageUrl: string
  isSelected: boolean
  isTypeDaily: boolean
  isTypePreorder: boolean
  isTypeDelivery: boolean
  preorderStocks: StockType[]
  selectBread: (event: ChangeEvent<HTMLInputElement>) => void
}

const TimeSaleProductCard: FC<Props> = (props) => {
  const {
    breadId,
    breadName,
    imageUrl,
    isSelected,
    isTypeDaily,
    isTypePreorder,
    isTypeDelivery,
    preorderStocks,
    selectBread,
  } = props

  return (
    <CardInner>
      <label className={styles.checkbox} htmlFor={breadId}>
        <input
          className={styles.checkbox__input}
          checked={isSelected}
          id={breadId}
          onChange={(e) => selectBread(e)}
          type="checkbox"
        />
        <span className={styles.checkbox__dummy_large} tabIndex={0} />
        <Spacer size={12} />
        <div className={styles.checkbox__image}>
          <img src={imageUrl} alt={breadName} />
        </div>
        <Spacer size={12} />
        <FlexColumn alignItems={'start'}>
          <span className={text.font_bold}>{breadName}</span>
          <Spacer size={8} />
          <FlexRow alignItems={'baseline'} justifyContent={'start'}>
            <div className={cardStyles.label}>
              <SmallLabel label={'注文タイプ ： '} />
            </div>
            <div className={cardStyles.tag}>
              {isTypeDaily && (
                <div className={cardStyles.tag__item}>
                  <LightTag color={'blue'} label={'当日'} />
                </div>
              )}
              {isTypePreorder && (
                <div className={cardStyles.tag__item}>
                  <BreadPreorderTag isConfigured={preorderStocks.length > 0} />
                </div>
              )}
              {isTypeDelivery && (
                <div className={cardStyles.tag__item}>
                  <LightTag color={'orange'} label={'取り寄せ'} />
                </div>
              )}
            </div>
          </FlexRow>
        </FlexColumn>
      </label>
    </CardInner>
  )
}

export default TimeSaleProductCard
